module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step3_Image3a.677a99e7.jpg";